import customAxios from "./axiosConfig";

const AvatarService = {
  retrieve: function (user_id) {
    var url = window.Urls["user_avatar_details"](user_id);
    return customAxios.get(url, { useCache: true });
  },
  retrieveNoCache: function (user_id) {
    var url = window.Urls["user_avatar_details"](user_id);
    return customAxios.get(url, { useCache: false });
  },
};

export default AvatarService;